:host {
  display: block;
  --button-height: 40px;
}
button.small,
button.outline {
  --button-height: 30px;
}

button.full {
  width: 100%;
}

button {
  display: inline-block;
  line-height: var(--button-height);
  height: var(--button-height);
  font-size: 16px;
  font-family: inherit;
  white-space: nowrap;
  padding: 0 16px;
  border: 0;
  border-radius: 2px;
  outline: none;
  text-align: center;
  appearance: none;
  cursor: pointer;
}

button.primary {
  background-color: var(--primary);
  border-color: var(--primary);
  color: white;
  font-weight: 600;

  &:hover {
    background-color: var(--text-links);
    border-color: var(--text-links);
  }
}

button.outline {
  background-color: var(--background);
  color: var(--text-body);
  background: none;
  border: 1px solid var(--border);
  padding: 0 12px;
  font-size: 14px;
  font-family: var(--body-font);
  line-height: 30px;
  font-weight: 400;

  &:hover {
    color: var(--primary);
    border-color: var(--primary);
  }
}

button.padded {
  padding: 0 42px;
}

button.uppercase {
  text-transform: uppercase;
}

button.icon-left,
button.icon-right {
  display: flex;
  align-items: center;
}

button.icon-left hd-icon {
  margin-right: 12px;
}

button.icon-right hd-icon {
  margin-left: 12px;
}

button[disabled] {
  opacity: 0.7;
  background-color: var(--disabled);
}
